function renderLargeProductCard() {
  // determine mobile or desktop
  function getDeviceSize() {
    const pagewidth = window.innerWidth;

    let isMobile = false;
    if (pagewidth < 990) {
      isMobile = true;
    }
    return isMobile;
  }

  function updateLargeProductCard() {
    const productGrid = document.querySelector('#product-grid');
    const largeCard = document.querySelector(
      '.grid__item[data-large-card="true"]',
    );

    if (productGrid && largeCard) {
      if (getDeviceSize() == false) {
        // move large card out of card list <ul>
        productGrid.insertAdjacentElement('afterend', largeCard);

        // create blank cards to make space for large product card
        let blankCards = document.querySelectorAll('#grid-item-large');
        if (blankCards.length < 1) {
          const cards = productGrid.querySelectorAll('.grid__item');
          if (cards[7]) {
            for (let i = 0; i < 2; i++) {
              const blankCard = document.createElement('li');
              blankCard.classList.add('grid__item');
              blankCard.classList.add('grid__item--large');
              blankCard.id = 'grid-item-large';
              cards[5].insertAdjacentElement('afterend', blankCard);
            }
            for (let i = 0; i < 2; i++) {
              const blankCard = document.createElement('li');
              blankCard.classList.add('grid__item');
              blankCard.classList.add('grid__item--large');
              blankCard.id = 'grid-item-large';
              cards[7].insertAdjacentElement('afterend', blankCard);
            }
          }
        }

        // insert large card into the space made
        blankCards = document.querySelectorAll('#grid-item-large');
        if (blankCards || blankCards.length) {
          blankCards[0].insertAdjacentElement('afterbegin', largeCard);
        }

        // style large card
        const { columnGap } = window.getComputedStyle(productGrid);
        const { rowGap } = window.getComputedStyle(productGrid);

        if (blankCards[0] && columnGap && rowGap) {
          blankCards[0].style.cssText = `
                        position: relative;
                    `;
          largeCard.style.cssText = `
                        position: absolute;
                        top: calc(25% + (${rowGap} / 2));
                        left: calc(25% + (${columnGap} / 2));
                        width: calc(150% - (${columnGap} / 2));
                        max-width: none;
                    `;
        }
      } else {
        // move large card out of card list <ul>
        productGrid.insertAdjacentElement('afterend', largeCard);

        // place large card after 6th card
        const cards = productGrid.querySelectorAll('.grid__item');
        if (cards[5]) {
          cards[5].insertAdjacentElement('afterend', largeCard);
        }

        // style large card
        largeCard.style.cssText = `
                    width: 100%;
                    max-width: none;
                `;
      }
    }
  }

  // on load
  updateLargeProductCard();

  // on click
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.variant-selector')) {
      updateLargeProductCard();
      setTimeout(() => {
        updateLargeProductCard();
      }, 1500);
    }
  });
}

export { renderLargeProductCard as default };
